import React from 'react';
import { FullHeightLayout, SimpleLayout } from '../../components/layout';
import Page from '../../components/page';
import { TooManyRequests } from '../../components/too-many-requests/too-many-requests';
import forDevice from '../../hoc/for-device';

const Layout = forDevice(FullHeightLayout, SimpleLayout);

export const TooManyRequestsPage = () => (
  <Page noSpacing data-hook="too-many-requests-page">
    <Layout>
      <TooManyRequests />
    </Layout>
  </Page>
);
